import { ReactElement } from 'react'
import {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType
} from 'next'

import Meta from '@/components/base/Meta'
import PageBuilder from '@/components/layout/Builder'
import Layout from '@/components/layout/Layout'
import { mapPageStaticProps } from '@/utils/pageData'
import { getPromiseFromFetch } from '@/utils/request'
import { API } from '@/constants'

import { WPPageData, WPRoutes } from '@/types'

export default function Page(
  pageData: InferGetStaticPropsType<typeof getStaticProps>
) {
  return <PageBuilder pageData={pageData} />
}

Page.getLayout = function getLayout(page: ReactElement, props: WPPageData) {
  return (
    <Layout pageData={props}>
      <Meta pageData={props} />
      {page}
    </Layout>
  )
}

export async function getStaticProps({
  params
}: GetStaticPropsContext<{ routes: string[] }>) {
  const res = await getPromiseFromFetch<WPPageData>({
    method: 'get',
    url: `/${params?.routes.join('/')}/`
  })

  if (res.status === 404) return { notFound: true }

  const { data: pageData } = res

  return {
    props: {
      ...(await mapPageStaticProps(pageData))
    }
  }
}

export async function getStaticPaths({}: GetStaticPathsContext) {
  const { data: routes } = await getPromiseFromFetch<WPRoutes>({
    method: 'get',
    url: API.ROUTES
  })

  return {
    paths: routes.map((route: { routes: string[] }) => ({ params: { routes: route.routes } })),
    fallback: 'blocking' // false
  }
}
